module.exports = __webpack_public_path__ + "img/l-hd.7b00da3d.webp";